module.exports = __webpack_public_path__ + "media/images/logo_small-c1789ef44ee24b744e4c8b60e00b357f.svg";